import React from 'react'
import styled from 'styled-components'
import EditIcon from '../../../../../../generic/icons/IconLib/PencilIcon'

type Props = {
  onClick: () => void
  children?: React.ReactNode
}

const NoteButton: React.FC<Props> = ({ onClick, children = 'הערה' }) => {
  return (
    <Button onClick={onClick}>
      <EditIcon />
      {children}
    </Button>
  )
}

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4em;
  padding: 0.4em 0.8em;
  background: #f0f4ff;
  color: #297F76;
  border: 2px solid #297F76;
  justify-content: flex-end;
  border-radius: 15px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;

  &:hover {
    background: #297F76;
    color: #fff;
    
    svg {
      color: #fff;
    }
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 1em; height: 1em;
    color: #297F76;
    transition: all 0.2s ease;
  }
`

export default NoteButton
